import React, { useMemo, useState } from 'react';
import DateScenarioPage from '../date-management/DateScenarioPage';
import useI18n from '../../i18n/useI18n';

const preferenceDateEndpoints = {
  list: ({ universityId, cityId }) => ({
    url: universityId
      ? `universities/${universityId}/preference-dates`
      : cityId
        ? `universities/cities/${cityId}/preference-dates`
        : '',
  }),
  create: ({ universityId }) => ({
    url: universityId ? `universities/${universityId}/preference-dates` : '',
  }),
  update: ({ universityId, recordId }) => ({
    url: universityId ? `universities/${universityId}/preference-dates/${recordId}` : '',
  }),
  delete: ({ universityId, recordId }) => ({
    url: universityId ? `universities/${universityId}/preference-dates/${recordId}` : '',
  }),
};

const preferenceGuideEndpoints = {
  list: ({ universityId, cityId }) => ({
    url: universityId
      ? `universities/${universityId}/preference-guides`
      : cityId
        ? `universities/cities/${cityId}/preference-guides`
        : '',
  }),
  create: ({ universityId }) => ({
    url: universityId ? `universities/${universityId}/preference-guides` : '',
  }),
  update: ({ universityId, recordId }) => ({
    url: universityId ? `universities/${universityId}/preference-guides/${recordId}` : '',
  }),
  delete: ({ universityId, recordId }) => ({
    url: universityId ? `universities/${universityId}/preference-guides/${recordId}` : '',
  }),
};

const PreferenceDatesPage = () => {
  const { t } = useI18n();
  const [activeTab, setActiveTab] = useState('preferenceDates');

  const tabs = useMemo(
    () => [
      {
        key: 'preferenceDates',
        label: t('PREFERENCE_DATES_TAB_PREFERENCE'),
        config: {
          titleKey: 'PREFERENCE_ONLY_DATES_TITLE',
          subtitleKey: 'PREFERENCE_ONLY_DATES_SUBTITLE',
          entityNameKey: 'DATE_SCENARIO_ENTITY_PREFERENCE',
          emptyStateKey: 'PREFERENCE_ONLY_DATES_EMPTY',
          addButtonKey: 'PREFERENCE_ONLY_DATES_ADD_BUTTON',
          scenarioType: 'preferenceDates',
          endpoints: preferenceDateEndpoints,
          usageInfoKey: 'PREFERENCE_ONLY_DATES_USAGE_INFO',
        },
      },
      {
        key: 'preferenceGuides',
        label: t('PREFERENCE_DATES_TAB_GUIDES'),
        config: {
          titleKey: 'PREFERENCE_GUIDES_TITLE',
          subtitleKey: 'PREFERENCE_GUIDES_SUBTITLE',
          entityNameKey: 'DATE_SCENARIO_ENTITY_PREFERENCE_GUIDE',
          emptyStateKey: 'PREFERENCE_GUIDES_EMPTY',
          addButtonKey: 'PREFERENCE_GUIDES_ADD_BUTTON',
          scenarioType: 'preferenceGuides',
          endpoints: preferenceGuideEndpoints,
          usageInfoKey: 'PREFERENCE_GUIDES_USAGE_INFO',
        },
      },
    ],
    [t]
  );

  const activeTabConfig = tabs.find((tab) => tab.key === activeTab) || tabs[0];

  const headerTabs = {
    items: tabs.map(({ key, label }) => ({ key, label })),
    activeKey: activeTabConfig.key,
    onSelect: setActiveTab,
  };

  return (
    <DateScenarioPage
      key={activeTabConfig.key}
      {...activeTabConfig.config}
      headerTabs={headerTabs}
    />
  );
};

export default PreferenceDatesPage;

